<form *ngIf="form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g-12">
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label required">{{ 'common.date_start' | translate }}</span>
      <app-kv-calendar
        #dateStartField
        [inputName]="'startDate'"
        [formData]="form"
        [startDateSelector]="true"
        [endDateInputName]="'endDate'"
        [endDateCalendar]="dateEndField"
        [defaultDate]="setDefaultDateStart()"
        [defaultValue]="setDefaultDateStart()"
      ></app-kv-calendar>
      <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['startDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
    </div>
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label required">{{ 'common.date_end' | translate }}</span>
      <app-kv-calendar
        #dateEndField
        [inputName]="'endDate'"
        [formData]="form"
        [defaultDate]="setDefaultDateEnd()"
        [defaultValue]="setDefaultDateEnd()"
        [endDateSelector]="true"
        [startDateInputName]="'startDate'"
        [startDateCalendar]="dateStartField"
      ></app-kv-calendar>
      <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['endDate'].errors?.required">{{ 'common.required_error' | translate }}</span>
    </div>
  </div>
  <div class="ui-g-12 text-center">
    <button
      class="k-generic-btn"
      pButton
      icon="fa fa-check"
      label="{{ 'common.save' |translate }}"
      (click)="save()">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/association-dates-form/association-dates-form.component.html